import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from 'primeng/api';
import { MaterialModule } from 'src/app/shared/material.module';
import { MatButtonModule } from '@angular/material/button';
import { MessageModule } from 'primeng/message';
import { DocumentLabelEnableModalComponent } from './documentlabel-enable-modal.component';


@NgModule({
	imports: [
		CommonModule,
		TranslateModule, 
		FormsModule, 
		ReactiveFormsModule, 
		SelectModule, 
		SharedModule, 
		MaterialModule, 
		MatDialogModule,
		MatButtonModule,
		MessageModule
	],
	declarations: [DocumentLabelEnableModalComponent],
	exports: [DocumentLabelEnableModalComponent, MessageModule],
})
export class DocumentLabelEnableModule {}
